import React from "react";
import { StatusTag } from "components/StatusTag";
import TestTag from "components/TestTag";
import { RESTRICTED_PROGRAM_CODES } from "constants/restrictedProgramCodes";

const SHARED_STYLES: React.CSSProperties = {
  fontFamily: "HelveticaNeue",
  margin: 0,
};

const MAIN_HEADER_STYLES: React.CSSProperties = {
  fontSize: "2.125rem",
  fontWeight: "bold",
  color: "#1f2226",
  letterSpacing: "0.6px",
  ...SHARED_STYLES,
};

const SECONDARY_HEADER_STYLES: React.CSSProperties = {
  ...SHARED_STYLES,
  fontSize: "0.875rem",
  fontWeight: 500,
  color: "#53626c",
  marginBottom: "0.5rem",
};

const MAIN_HEADER_CONTAINER: React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
};

const ACCESS_TEXT_STYLES: React.CSSProperties = {
  fontSize: "0.75rem",
  fontWeight: 500,
  color: "#53626c",
  marginLeft: "0.5rem",
};

const getAccessText = (impactTier: string | undefined, programCode: string): string | null => {
  if (!programCode) return null;

  // Check if this program code is in the restricted list
  const matchedProgramCode = RESTRICTED_PROGRAM_CODES.find(code => code === programCode);

  if (!matchedProgramCode) return null;

  // BCBSAR-ACA-2026 always shows web portal only regardless of impact tier
  if (matchedProgramCode === "BCBSAR-ACA-2026") {
    return "Rewards Web Portal Only";
  }

  // If no impact tier, default to web portal only
  if (!impactTier) {
    return "Rewards Web Portal Only";
  }

  const tier = impactTier.toLowerCase();

  if (tier === "minimal") {
    return "Rewards Web Portal Only";
  } else if (["standard", "high", "extreme"].includes(tier)) {
    return "Rewards Web Portal & Mobile Access";
  }

  return null;
};

interface Props {
  shortId: string;
  fullName: string;
  isTestMember: boolean;
  programCode: string;
  status: string;
  handleTestMember?: (event?: any) => void;
  impactTier?: string;
}

export default ({
  shortId,
  fullName,
  isTestMember,
  handleTestMember,
  programCode,
  status,
  impactTier,
}: Props) => {
  const accessText = getAccessText(impactTier, programCode);

  return (
    <>
      <div style={MAIN_HEADER_CONTAINER}>
        <h3 style={MAIN_HEADER_STYLES}>{shortId}</h3>
        <TestTag isTestUser={isTestMember} handleTestUser={handleTestMember} />
        {accessText && <span style={ACCESS_TEXT_STYLES}>{accessText}</span>}
      </div>
      <h5 style={SECONDARY_HEADER_STYLES}>{fullName}</h5>
      <StatusTag programCode={programCode} status={status} />
    </>
  );
};
